import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { useClientStore, useNoAuthRedirect } from 'apps/hooks';
import { useAppManager } from 'core/hooks';

import { Header } from 'libs/rendering/components/header';
import DocumentHead from 'legacyComponents/documentHead';

import ShareInputFile from 'apps/share/blocks/ShareInputFile';
import UploadSharedFileAppManager from 'apps/share/uploadSharedFile/appManager';

const SharePage = withNamespaces()(
  observer(props => {
    const clientStore = useClientStore();
    const shouldCreate = !!clientStore.signedInProfile;
    const sharedFileManager = useAppManager(
      UploadSharedFileAppManager,
      null,
      props,
      shouldCreate,
    );
    useNoAuthRedirect();

    if (!sharedFileManager) return null;

    return (
      <main>
        <DocumentHead title='Share' />
        <Header />
        <ShareInputFile
          clientStore={clientStore}
          sharedFileManager={sharedFileManager}
        />
      </main>
    );
  }),
);

SharePage.propTypes = {
  routerStore: PropTypes.object,
  clientStore: PropTypes.object,
};

export default SharePage;
